<template>
  <navBack></navBack>
  <div class="page">
    <div class="topBox">
      <div class="secondBar">
        <div class="sheetInfo">
          <t-button @click="choseDate(0)" variant="text">{{ startDate }}</t-button>
         <t-icon name="arrow-down" color="gray" />
          <text class="txtSpan">至</text>
          <t-button @click="choseDate(1)" variant="text">{{ endDate }}</t-button>
                 <t-icon name="arrow-down" color="gray" />
        </div>

        <div class="sheetInfo">
          <!-- 类型选择可以按需添加 -->
        </div>
      </div>
    </div>

    <div class="body" @scroll="handleScroll">
      <div v-for="(item, index) in dataList" :key="item._id" class="logItem" @tap="showOrder(index)">
        <div class="leftSection">
          <div class="title">{{ item.beiz }}</div>
          <div class="time">{{ item.createAt.time2 }}</div>
        </div>
        <div class="rightSection">
          <div class="amount">{{ item.pointAmount }}</div>
          <div class="currentAmount">结余: {{ item.leftAmount }}</div>
        </div>
      </div>

      <t-empty v-if="dataList.length === 0" description="没有记录" />
    </div>

    <!-- 日期选择弹窗 -->
    <t-popup v-model:visible="showDatePicker" placement="bottom">
      <t-date-time-picker 
        v-model="editDate" 
        mode="date" 
        title="选择时间" 
        format="YYYY-MM-DD" 
        @confirm="onDateConfirm"
        @cancel="showDatePicker = false" 
      />
    </t-popup>
  </div>
</template>

<script setup>
import { ref,   onMounted,getCurrentInstance } from 'vue'
import dayjs from 'dayjs'
import { useRoute } from "vue-router";
import { Toast } from 'tdesign-mobile-vue';
import navBack  from '@/components/nav-back.vue'
// 日期相关
const { proxy } = getCurrentInstance();

const app = proxy.$cloudbase; // Optional chaining to safely access $cloudbase
const auth = proxy.$auth;
const startDate = ref(dayjs().subtract(12, 'month').format('YYYY-MM-DD'))
const endDate = ref(dayjs().format('YYYY-MM-DD'))
const editDate = ref(dayjs().format('YYYY-MM-DD'))
const route = useRoute();
// 控制显示
const showDatePicker = ref(false)
const editDateType = ref(0) // 0: startDate, 1: endDate

const isOver = ref(false);
const pageIndex = ref(1);

// 数据列表
const dataList = ref([])
const customer_Id = ref('')
// 选择日期
const choseDate = (type) => {
  showDatePicker.value = true
  editDateType.value = type
  editDate.value = type === 0 ? startDate.value : endDate.value
}


const loadPointLogList = async () => {
  if (isOver.value) {
    Toast('没有更多');
    return;
  }

  try {
    await auth.signInAnonymously();
    const db = app.database();
 
    const customerId = customer_Id.value;

    const _ = db.command;
    let queryData = {
      'status': _.gt(0)
     
    };
    if (customerId) {
      queryData['customerId'] = customerId;
    }

     queryData['createAt.time3'] = _.and(_.gte(startDate.value), _.lte(endDate.value));

    // switch (typeIndex.value) {
    //   case 1:
    //     queryData['type'] = _.in([0,1,5]);
    //     break;
    //   case 2:
    //     queryData['type'] = 4;
    //     break;
    //   case 3:
    //     queryData['type'] = 2;
    //     break;
    //   case 4:
    //     queryData['type'] = 3;
    //     break;
    //   case 5:
    //     queryData['status'] = -1;
    //     break;
    // }

    const _pageSize = 20;
    const _skipNum = Math.floor((pageIndex.value - 1) * _pageSize);

    const res = await db.collection("my_customer_point_log")
      .where(queryData)
      .orderBy('createAt.timeStamp', 'desc')
      .skip(_skipNum)
      .limit(_pageSize)
      .get();

    if (res.data.length < _pageSize) {
      isOver.value = true;
    }
    pageIndex.value++;
    dataList.value = [...dataList.value, ...res.data];
  } catch (error) {


    Toast('加载失败');

  }
};

const handleScroll = async (e) => {
  // 如果正在加载或已经加载完所有数据，则直接返回
  if ( isOver.value) return;
  
  const { scrollTop, scrollHeight, clientHeight } = e.target;
  
  // 当滚动到底部附近时触发加载（距离底部50px）
  if (scrollHeight - scrollTop - clientHeight < 50) {
 
      await loadPointLogList();
    
  }
}
// 日期确认
const onDateConfirm = (value) => {
  if (editDateType.value === 0) {
    startDate.value = value
  } else {
    endDate.value = value
  }
  showDatePicker.value = false
  loadDataList() // 重新加载数据
}

// 显示订单详情
const showOrder = (index) => {
  console.log('查看订单详情，索引:', index)
  // 实现跳转逻辑
}

// 加载数据列表
const loadDataList = async () => {
  try {
    // 这里实现实际的数据加载逻辑
    // 示例数据
    dataList.value = [
      {
        _id: '1',
        pointAmount: '+100',
        leftAmount: '500',
        beiz: '消费获得积分',
        createAt: {
          time2: '2023-06-01 10:30'
        }
      },
      {
        _id: '2',
        pointAmount: '-50',
        leftAmount: '450',
        beiz: '兑换商品',
        createAt: {
          time2: '2023-06-05 15:20'
        }
      }
    ]
  } catch (error) {
    console.error('加载数据失败:', error)
  }
}

// 组件挂载时加载数据
onMounted(() => {
  console.log(route.query,'route')
  customer_Id.value = route.query.id
  loadDataList()
})
</script>

<style scoped>
 
.topBox{
  height:6vw;
 
 
  padding:0 1vw;
 
}
.logItem{
  display: flex;
  justify-content: space-between;
  padding:3vw 5vw;
  border-bottom: 0.5px solid rgb(231, 231, 231);
  font-size: 12px;
  line-height: 20px;
}
.logItem .leftSection{
  width:50vw;
}
.logItem .leftSection  .title{
  font-size: 16px;
    display: block;

}
.logItem .rightSection{
  width:35vw;
  text-align: right;

}

.logItem .rightSection .amount{
  font-weight: 600;
  font-size: 16px;
  display: block;
}
.logItem .leftSection .time{
  color: gray;
  display: block;
}
.secondBar{
  display: flex;
  justify-content: space-between;
 
}
.sheetInfo{
  padding-top:2vw;
  display: flex;
  font-size: 0.9rem;
  align-items: center;
}
.sheetInfo .txtSpan{
  padding:0 1vw;
}

</style>